class PartsTable extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.table = this.querySelector('.parts-table');
    if (!this.table) return;
    this.init();
  }

  init() {
    // this modal contains a contact form. Opens when a request a quote button is clicked.
    // It's message input box is prepopulated with the product part info.
    this.requestAQuoteModal = document.getElementById('requestAQuoteModal');
    if (!this.requestAQuoteModal) return;

    // Contact Form message box to prepopulate with product part info on reques-a-quote clicked
    this.contactMessageBox = this.requestAQuoteModal.querySelector('#ContactForm-body');
    if (!this.contactMessageBox) return;

    const buttons = Array.from(this.querySelectorAll('.button-request-a-quote'));
    if (!buttons) return;

    this.modalProductPartLink = document.querySelector('[data-modal-product-part-link]');
    if (!this.modalProductPartLink) return;

    this.requestAQuoteClickedHandler = this.requestAQuoteClicked.bind(this);

    buttons.forEach((btn) => {
      btn.addEventListener('click', this.requestAQuoteClickedHandler);
    });
  }

  requestAQuoteClicked(e) {
    const row = e.target.closest('tr');
    if (!row) return;

    const link = row.querySelector('[data-title] a');
    if (!link) return;

    this.modalProductPartLink.textContent = link.textContent;
    this.modalProductPartLink.setAttribute('href', link.href);
    this.modalProductPartLink.closest('div').classList.remove('hidden');

    const messageJSON = this.generateProductInfoFromRow(e.target.closest('tr'));
    this.contactMessageBox.value = `Title: ${this.dataset['productTitle']}\nURL: ${link.href}  \n\n Product Information :\n\t${messageJSON}\n\n\nComments/Questions:\n\n\n`;
  }

  generateProductInfoFromRow(tr) {
    let info = Array.from(tr.querySelectorAll('td')).map((td) =>
      td.textContent.trim().replaceAll(' ', '').replaceAll('\n\n', ': ')
    );
    info.pop(); // pop request a quote button column
    info.pop(); // pop quantity column

    // add quanty info manually
    const quantityInput = tr.querySelector('[name="quantity"]');
    if (quantityInput) info.push(`Quantity: ${quantityInput.value}`);

    return info.join(',\n\t');
  }
}

customElements.define('parts-table', PartsTable);

/**
 * This custom element is for the html parts table.
 * HTML parts table is what we call the html rendered in the product metafield 'p80.partsTable'.
 * The metafield contains an html text of the table which will then be rendered directly in the section.
 *
 */
class PartsTableHTML extends HTMLElement {
  constructor() {
    super();

    // some products have multiple tables so we use an array to store all table elements
    this.tables = Array.from(this.querySelectorAll('table'));
    if (!this.tables || this.tables.length == 0) return;

    // button template for 'request a quote' buttons.
    this.requestAQuoteButtonTemplate = this.querySelector('#requestAQuoteButtonTemplate');

    // get add to cart button template
    this.addToCartButtonTemplate = this.querySelector('#quick-add-to-cart-template');

    if (!this.requestAQuoteButtonTemplate) return;

    this.modalProductPartLink = document.querySelector('[data-modal-product-part-link]');

    // this modal contains a contact form. Opens when a request a quote button is clicked.
    // It's message input box is prepopulated with the product part info.
    this.requestAQuoteModal = document.getElementById('requestAQuoteModal');
    if (!this.requestAQuoteModal) return;

    // Contact Form message box to prepopulate with product part info on reques-a-quote clicked
    this.contactMessageBox = this.requestAQuoteModal.querySelector('#ContactForm-body');
    if (!this.contactMessageBox) return;

    this.barrEcomMinQuantity =
      this.dataset.ecomMinQuantity && !isNaN(this.dataset.ecomMinQuantity)
        ? parseInt(this.dataset.ecomMinQuantity)
        : 1;
    this.tables.forEach((table) => {
      let tableClone = table.cloneNode(true); //the table is cloned and will be replaced with the copy wrapped with a div
      this.createRowButtons(tableClone);
      this.generalizeColumnHeaders(tableClone);
      this.setCellHeaderAttributes(tableClone);
      this.createTableWrapper(tableClone, table);
    });
  }

  /**
   * Creates a div wrapper for tables.
   * @param {table element} table
   */
  createTableWrapper(tableClone, table) {
    let container = document.createElement('div');
    container.classList.add('parts-table-wrapper');

    // this.insertBefore(container, table); // add wrapper to DOM before the table
    container.appendChild(tableClone); // move table inside wrapper
    table.replaceWith(container);
  }

  /**
   * @param {table element} table
   * clones the request-a-quote button template then adds to the end of the rows of the tbody.
   */
  createRowButtons(table) {
    const rows = Array.from(table.querySelectorAll('tr'));
    if (!rows) return;
    table.tableRawHeaders = []; //use to store tr elements containing th elements
    rows.forEach((row, index) => {
      //if row is header row
      if (index === 0 || (row.querySelector('th') && row.childElementCount > 1)) {
        if (index < 2) {
          table.tableRawHeaders.push(row);
          row.classList.add('table-header-row');
        } else row.appendChild(document.createElement('th'));
        return;
      }

      if (!row.hasChildNodes()) return;

      if (row.childElementCount == 1) {
        let onlychild = row.querySelector('td, th');
        onlychild.colSpan += 1;
        return;
      }

      const productLink = row.querySelector('[href*="products"]');
      if (productLink) {
        this.createButtonFromProductInfo(
          productLink.href.split('/products/')[1].split('/')[0],
          row
        );
      } else {
        const button = this.createRequestAQuoteButton();
        const cell = document.createElement('td');
        cell.appendChild(button);
        row.appendChild(cell);
      }
    });
  }

  /**
   * This adds an add-to-cart button to row if the product is available. Request a quote other wise.
   * @param {product Object} productName
   * @param {<tr> element} row
   */
  createButtonFromProductInfo(productName, row) {
    let cell = document.createElement('td');
    const partsTable = this;
    fetch(`${productName}.json`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (
          (data.product.variants[0].inventory_quantity === 0 ||
            data.product.variants[0].inventory_quantity < this.barrEcomMinQuantity) &&
          data.product.variants[0].inventory_policy !== 'continue'
        ) {
          throw new Error('Product unavailable'); // this will create a R-a-Q button instead
        }
        const button = partsTable.createAddToCartButton(data.product);
        cell = document.createElement('td');
        cell.appendChild(button);
        row.appendChild(cell);
      })
      .catch((error) => {
        const button = partsTable.createRequestAQuoteButton();
        cell = document.createElement('td');
        cell.appendChild(button);
        row.appendChild(cell);
      });
  }

  /**
   * @param {Product Object} product
   * @returns This returns a product-form component
   */
  createAddToCartButton(product) {
    const quickAddToCart = this.addToCartButtonTemplate.content.cloneNode(true);

    const idInput = quickAddToCart.querySelector('input[name="id"]');
    idInput.value = product.variants[0].id;

    const qtyInput = quickAddToCart.querySelector('input[name="quantity"]');
    qtyInput.setAttribute(
      'aria-label',
      `${product.title.replaceAll('"', '').replaceAll("'", '')} quantity`
    );

    if (
      product.variants[0].inventory_quantity === 0 &&
      product.variants[0].inventory_policy !== 'continue'
    ) {
      const submitButton = quickAddToCart.querySelector('button[type="submit"]');
      submitButton.setAttribute('disabled', '');
    }

    return quickAddToCart;
  }

  /**
   * @returns returns a modal opener (Request a Quote button) for the Request a quote form
   */
  createRequestAQuoteButton() {
    const modalOpener = this.requestAQuoteButtonTemplate.content.cloneNode(true);
    const modalOpenerButton = modalOpener.querySelector('button');

    modalOpenerButton.addEventListener('click', this.requestAQuoteClicked.bind(this));
    return modalOpener;
  }

  /**
   * Tables are assumed to have 1 or 2 header rows.
   * This function combines the header rows into a single row matching the number of columns needed for the table body.
   * Returns an array of string containing the combined rows' header text contents.
   * e.g.
   *         | product name |    Weight    | sku |
   *         |              |  kg  |  lb   |     |
   *
   * output ["product name", "Weight (kg)", "Weight (lb)", sku]
   */
  generalizeColumnHeaders(table) {
    //add check if the table has headers
    if (table.tableRawHeaders.length === 0) return;
    table.tableHeaders = [];

    const primaryHeader = Array.from(table.tableRawHeaders[0].querySelectorAll('th'));

    const lastThead = document.createElement('th'); // add table header for the 'request a quote' buttons

    if (table.tableRawHeaders.length == 1) {
      table.tableHeaders = primaryHeader.map((cell) => cell.textContent.trim());
      table.tableRawHeaders[0].appendChild(lastThead);
      return;
    }

    const secondaryHeader = Array.from(table.tableRawHeaders[1].querySelectorAll('th'));

    let ctr = 0;
    primaryHeader.forEach((cell) => {
      if (cell.rowSpan > 1) {
        table.tableHeaders.push(cell.textContent.trim());
        return;
      }

      for (let index = ctr; index < ctr + cell.colSpan; index++) {
        let header = `${cell.textContent.trim()} (${secondaryHeader[index].textContent.trim()})`;
        table.tableHeaders.push(header);
      }
      ctr += cell.colSpan;
    });

    lastThead.rowSpan = 2;
    table.tableRawHeaders[0].appendChild(lastThead);
  }

  requestAQuoteClicked(e) {
    const targetTr = e.target.closest('tr');
    const table = e.target.closest('table');
    const mesasgeJSON = this.generateProductInfoFromRow(
      Array.from(targetTr.querySelectorAll('td')),
      table
    );
    this.contactMessageBox.value = `Title: ${this.dataset['productTitle']}\nURL: ${this.dataset['productLink']}  \n\n Product Information :\n ${mesasgeJSON}\n\n\nComments/Questions:\n\n\n`;
    this.modalProductPartLink.textContent = '';
    this.modalProductPartLink.closest('div').classList.add('hidden');
  }

  /**
   * @param { array of td elements } cells
   * @param { table element } table
   * @returns { string } key value pairs to prepopulate the contact form body in the request-a-quote modal.
   * The key value pairs are composed
   */
  generateProductInfoFromRow(cells, table) {
    if (cells.length == 0) return;
    let obj = [];
    cells.pop(); // remove request a quote button cell
    cells.forEach((cell, index) => {
      obj.push(
        `\t ${table.tableHeaders[index]}: ${cell.textContent ? cell.textContent.trim() : 'N/A'}`
      );
    });
    return obj.join(',\n');
  }

  /**
   * This sets the data-header attributes of tables cells(td).
   * The attribute is used in the section-parts-table.css.
   * It is set as the content for the cells ::before pseudo
   * which will serve as label in small screans where the main table headers are hidden.
   * @param {table element}
   * @returns
   */
  setCellHeaderAttributes(table) {
    let headerReference = this.primaryHeader; // if theres only one header row
    if (this.secondaryHeader) headerReference = this.secondaryHeader; // if there are 2 header rows

    const rows = Array.from(table.querySelectorAll('tr'));
    if (!rows) return;

    /**
     * the following conditions checks the length of columns and sets at what screen size does responsive styles
     * starts to take effect base on the column counts.
     */
    if (table.tableHeaders.length > 7) {
      table.classList.add('responsive--large'); // the table becomes responsive @width < 1199
    } else if (table.tableHeaders.length > 4) {
      table.classList.add('responsive--medium'); // the table becomes responsive @width < 989
    } else {
      table.classList.add('responsive--small'); // the table becomes responsive @width < 749
    }

    rows.forEach(
      function (row, index) {
        if (row.querySelector('th') || !row.hasChildNodes() || row.childElementCount === 1) {
          // exclude header rows
          return;
        }

        const cells = Array.from(row.querySelectorAll('td'));
        cells.forEach(
          function (td, index) {
            if (!this.tableHeaders[index]) return;
            td.setAttribute('data-header', this.tableHeaders[index]);
          }.bind(this)
        );
      }.bind(table)
    );
  }
}

customElements.define('parts-table-html', PartsTableHTML);
